<template>
  <transition name="fade-up-slide">
    <div class="lr2-modal" v-show="show" @click="close">
      <div class="lr-box" @click.stop>
        <div class="lr-box-head">How many are you traveling with?</div>

        <div class="d-flex justify-space-between trav-form">
          <label>Adults</label>
          <div class="d-flex align-center trav-counter">
            <i :class="['fas fa-minus-circle', {maxed:adults === 1}]" @click="minus('adults')"></i>
            <span>{{ adults }}</span>
            <i :class="['fas fa-plus-circle', {maxed:adults === 10}]" @click="add('adults')"></i>
          </div>
        </div>

        <div class="d-flex justify-space-between trav-form">
          <label>
            Children
            <span>Ages 2 to 12</span>
          </label>
          <div class="d-flex align-center trav-counter">
            <i :class="['fas fa-minus-circle', {maxed:children === 0}]" @click="minus('children')"></i>
            <span>{{ children }}</span>
            <i :class="['fas fa-plus-circle', {maxed:children === 10}]" @click="add('children')"></i>
          </div>
        </div>

        <div class="d-flex justify-space-between trav-form">
          <label>
            Infants
            <span>Below 2 years old</span>
          </label>
          <div class="d-flex align-center trav-counter">
            <i :class="['fas fa-minus-circle', {maxed:infants === 0}]" @click="minus('infants')"></i>
            <span>{{ infants }}</span>
            <i :class="['fas fa-plus-circle', {maxed:infants === 10}]" @click="add('infants')"></i>
          </div>
        </div>

        <div class="d-flex trav-btn-box">
          <span class="lr-btn" @click="apply">Search</span>
        </div>

        <div class="trav-notes">Note: Maximum of 2 luggage per passenger.</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'travellers',
  props: ['noCommit'],
  data () {
    return {
      adults: 1,
      children: 0,
      infants: 0
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    travellers () { return this.booking.filters.travellers },
    show () { return this.travellers.show }
  },
  methods: {
    close () {
      this.$store.commit('booking/setTravellersData', {show: false})
    },
    minus (x) {
      if ((x === 'adults' && this.adults === 1) || (x !== 'adults' && this[x] === 0)) return
      this[x]--
    },
    add (x) {
      if (this[x] === 10) return
      this[x]++
    },
    apply () {
      let total = this.adults + this.children + this.infants
      if (this.noCommit) {
        this.$emit('travelersVal', {
          total: total,
          adult: this.adults,
          children: this.children,
          infants: this.infants
        })
      } else {
        this.$store.commit('booking/setTravellersData', {
          total: total,
          adult: this.adults,
          children: this.children,
          infants: this.infants
        })

        this.$emit('submit')

        if (window.gtag) { // eslint-disable-line
          gtag( // eslint-disable-line
            'event',
            'Flight Booking - Travel Count',
            {
              total: total,
              adult: this.adults,
              children: this.children,
              infants: this.infants
            }
          )
        }
      }
      this.close()
    }
  },
  mounted () {
    this.adults = this.travellers.adult
    this.children = this.travellers.children
    this.infants = this.travellers.infants
  }
}
</script>

<style lang="scss" scoped>
.lr-box{
  padding: 20px 30px;
  width: 100%;
  max-width: 470px;
  text-align: left;
  line-height: 1;
}
.lr-box-head{
  color: #192024;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: .6px;
  margin-bottom: 30px;
}
.trav-form{
  margin-bottom: 30px;
  label{
    font-size: 21px;
    color: #192024;

    span{
      display: block;
      font-size: 14px;
      color: #5E6E7F;
      margin-top: 3px;
      letter-spacing: .5px;
    }
  }
  .trav-counter{
    gap: 10px;

    i{
      font-size: 25px;
      color: #5E6E7F;
      cursor: pointer;

      &.maxed{
        color:#BEBEBE;
        cursor: default;
      }
    }
    span{
      display: inline-block;
      text-align: center;
      width: 40px;
      font-size: 21px;
      font-weight: 600;
    }
  }
}
.lr-btn{
  margin-left: auto;
  padding: 20px 50px;
  font-size: 16px;
  margin-bottom: 30px;
}
.trav-notes{
  font-size: 13px;
  letter-spacing: .5px;
  text-align: center;
}

@media only screen and (max-width: 641px) {
  .lr2-modal{
    overflow: none;
  }
  .lr-box{
    height: 100%;
    max-width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  .trav-btn-box{
    flex-grow: 1;
    align-items: end;

    .lr-btn{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// TravellersModal.vue?c07364a0